// eslint-disable-next-line import/no-cycle
import { ComponentNameEnum } from '@/types';
// eslint-disable-next-line import/no-cycle
import { UserState } from '@/composables/User';

const listFields = [
  { label: 'templateBuilder.fields.lastname', value: 'spm_form_registration_last_name' },
  { label: 'templateBuilder.fields.firstname', value: 'spm_form_registration_first_name' },
  { label: 'templateBuilder.fields.email', value: 'spm_form_registration_email' },
  { label: 'templateBuilder.fields.password', value: 'spm_form_registration_password' },
  { label: 'templateBuilder.fields.birthday', value: 'spm_form_registration_birthday' },
];

const getFormFieldsFieldConfig = (
  defaultValue = [],
  mandatoryFields: string[] = [],
) => {
  const isShopify = UserState.activeShop?.solutionEcommerce === 'shopify';

  // Shopify: Filter out password field (Shopify handles authentication)
  const filteredFields = isShopify
    ? listFields.filter((field) => field.value !== 'spm_form_registration_password')
    : listFields;

  const filteredMandatoryFields = isShopify
    ? mandatoryFields.filter((field) => field !== 'spm_form_registration_password')
    : mandatoryFields;

  return {
    componentName: ComponentNameEnum.MULTIDROPDOWN,
    options: {
      list: filteredFields,
      defaultValue,
      mandatoryFields: filteredMandatoryFields,
    },
  };
};

export default getFormFieldsFieldConfig;
